import { VENDOR_PATHS } from './vendor-manifest';

// 成果物が xlsx を自前で組み立てるには OOXML の XML 名前空間を文字列で持つ必要がある。
// 名前空間は識別子で通信・遷移には使われないため、本文の URL 検査から除く（BE の upload_validation と同じ規則）。
// 末尾の `/` まで一致させ、別ホスト（`schemas.openxmlformats.org.example.com` 等）を通さない。
const OOXML_NAMESPACE_PREFIX = 'http://schemas.openxmlformats.org/';

function containsExternalUrlText(html: string): boolean {
  return [...html.matchAll(/https?:\/\//gi)].some(
    (match) => !html.startsWith(OOXML_NAMESPACE_PREFIX, match.index),
  );
}

/** 配信される custom-dashboard HTML に共通する安全・配信規約を検査する。 */
export function staticValidate(html: string): string[] {
  const violations: string[] = [];
  const reject = (condition: boolean, message: string) => {
    if (condition) violations.push(message);
  };

  reject(/<!doctype\b/i.test(html), 'DOCTYPEは使用できません');
  reject(/<(?:html|head|meta|title|link|object|iframe)\b/i.test(html), '禁止要素を含んでいます');
  reject(/<meta\b[^>]*http-equiv\s*=\s*["']?refresh\b/i.test(html), 'meta refreshは使用できません');
  reject(containsExternalUrlText(html), '外部URLを参照できません');
  reject(/<(?:form|base)\b/i.test(html), 'form/baseは使用できません');
  reject(/\b(?:fetch|XMLHttpRequest|WebSocket)\s*\(/.test(html), '直接の外部接続は使用できません');
  reject(/\baccountId\s*:/.test(html), 'accountIdをHTMLから指定できません');

  const document = new DOMParser().parseFromString(html, 'text/html');
  const vendorSources = [...document.querySelectorAll('script[src]')].map(
    (script) => script.getAttribute('src') ?? '',
  );
  const unknownVendorSources = vendorSources.filter(
    (source) => !VENDOR_PATHS.includes(source as (typeof VENDOR_PATHS)[number]),
  );
  if (unknownVendorSources.length > 0) {
    violations.push(`manifest外のvendor参照です: ${[...new Set(unknownVendorSources)].join(', ')}`);
  }

  return violations;
}
